import { render, staticRenderFns } from "./OuterLayout.vue?vue&type=template&id=8e18440a"
import script from "./OuterLayout.vue?vue&type=script&lang=js"
export * from "./OuterLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports